module.exports = __webpack_public_path__ + "static/Sweetgreen_pin-11b3c35805c3bdbcf682995f9352402a.png";